import {FullPopupRestDto, PopupRestDto} from "@/api/pharma-cms-popup/models";
import {PopupRestDtoModel} from "@/models/api/pharma-cms-popup/PopupRestDtoModel";

export class FullPopupRestDtoModel implements FullPopupRestDto {
    content_id: string;
    popup: PopupRestDto|null;

    constructor(content_id: string, popup: PopupRestDto|null) {
        this.content_id = content_id;
        this.popup = popup;
    }

    public static createWithDefaults(): FullPopupRestDtoModel {
        return new this('', PopupRestDtoModel.createWithDefaults());
    }
}
